// extracted by mini-css-extract-plugin
export var contentWrapper = "PageLayout-module--contentWrapper--f53f4";
export var root = "PageLayout-module--root--abd17";